<template>
	<div class="change-form">
        <div slot="header" class="header">
            <h4>Change Phone</h4>
        </div>
        <div class="change-section">
            <h5>Enter Phone Number</h5>
            <el-input placeholder="Please input" @focus="setValidation" @blur="removeValidation" v-model="newPhone" size="small">
            </el-input>
            <div v-if="showValidation" class="validation">{{ validationText }}</div>
			<ChangeButtons @change="phoneChange" @cancel="cancel" ></ChangeButtons>
        </div>
    </div>
</template>

<script>
import validatePhone from '../../util/valid-phone'
import ChangeButtons from './ChangeButtons'

export default {
	name: 'change-phone',

	data() {
		return {
            newPhone: null,
            showValidation: null
		}
    },
	watch: {
		newPhone(value) {
            if (validatePhone(value) == false)
                this.showValidation = true
            else
                this.showValidation = false
		}
	},
    methods: {
        phoneChange() {
			this.$emit('change', {
				newPhone: this.newPhone
			})
		},
		cancel() {
			this.$emit('cancel')
        },
		removeValidation() {
			this.showValidation = false
		},
		setValidation() {
			if (validatePhone(this.newPhone) == false)
                this.showValidation = true
            else
                this.showValidation = false
		}
    },
	computed: {
        validationText() {
            return 'Please type in at least 10 digits'
        }
    },
    components: {
        ChangeButtons
    }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>